enum HttpStatusCodes {
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  UNPROCESSABLE_ENTITY = 422,
  INTERNAL_SERVER_ERROR = 500
}

const SUCCESS_CODES = [HttpStatusCodes.OK, HttpStatusCodes.NO_CONTENT, HttpStatusCodes.CREATED]

export { HttpStatusCodes, SUCCESS_CODES }
